import { IShortItem, ITableRes } from 'types'
import { baseApi } from './baseApi'

export const setupAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    // Setup options 
    GET_setupOptions: builder.query<any, void>({
      query: () => ({
        url: '/setup-options/'
      }),
      providesTags: ['setup-options'],
    }),
    POST_setupOptionEnable: builder.mutation<any, string>({
      query: (id) => ({
        url: `/setup-options/${id}/enable/`,
        method: 'POST',
      }),
      invalidatesTags: ['setup-options'],
    }),
    POST_setupOptionDisable: builder.mutation<any, string>({
      query: (id) => ({
        url: `/setup-options/${id}/disable/`,
        method: 'POST',
      }),
      invalidatesTags: ['setup-options'],
    }),

    // Accommodation Categories
    GET_accommodationCategories: builder.query<any, any>({
      query: (params) => ({
        url: '/accommodation-categories/',
        params,
      }),
      providesTags: ['accommodation-categories'],
    }),
    POST_accommodationCategoryEnable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/accommodation-categories/${id}/enable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['accommodation-categories'],
    }),
    POST_accommodationCategoryDisable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/accommodation-categories/${id}/disable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['accommodation-categories'],
    }),
    GET_accommodationCategoriesSelect: builder.query<any, any>({
      query: (params) => ({
        url: '/accommodation-categories/',
        params
      }),
      transformResponse: (response: any, meta: any, arg: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        const list = response?.results.filter(r => !arg.is_enabled || (r.is_enabled === arg.is_enabled))
        return {
          list: list || [],
          count,
          hasMore,
        }
      },
      providesTags: ['accommodation-categories', 'accommodations'],
    }),

    // Accommodations
    GET_schoolSetupAccommodations: builder.query<any, any>({
      query: (params) => ({
        url: '/accommodations/',
        params,
      }),
      providesTags: ['accommodations'],
    }),
    GET_schoolSetupAccommodationById: builder.query<any, any>({
      query: (id) => {
        return {
          url: `/accommodations/${id}/`,
        }
      },
      providesTags: ['accommodations'],
    }),
    POST_schoolSetupAccommodation: builder.mutation<any, any>({
      query: (body) => ({
        url: `/accommodations/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['accommodations'],
    }),
    PATCH_schoolSetupAccommodation: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/accommodations/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['accommodations'],
    }),
    DELETE_schoolSetupAccommodation: builder.mutation<any, number>({
      query: (id) => ({
        url: `/accommodations/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['accommodations'],
    }),
    GET_schoolSetupAccommodationsSelect: builder.query<any, any>({
      query: (params) => ({
        url: '/accommodations/',
        params
      }),
      transformResponse: (response: any, meta: any, arg: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        let list = response?.results.filter(r => !arg.is_enabled || (r.is_enabled === arg.is_enabled))
        if(arg.categories)
          list = list.filter(r => r.category && arg.categories.includes(r.category.id))

        return {
          list: list || [],
          count,
          hasMore,
        }
      },
      providesTags: ['accommodations'],
    }),

    // Modification Categories
    GET_modificationCategories: builder.query<any, any>({
      query: (params) => ({
        url: '/modification-categories/',
        params,
      }),
      providesTags: ['modification-categories'],
    }),
    POST_modificationCategoryEnable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/modification-categories/${id}/enable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['modification-categories'],
    }),
    POST_modificationCategoryDisable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/modification-categories/${id}/disable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['modification-categories'],
    }),
    GET_modificationCategoriesSelect: builder.query<any, any>({
      query: (params) => ({
        url: 'modification-categories/',
        params
      }),
      transformResponse: (response: any, meta: any, arg: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        const list = response?.results.filter(r => !arg.is_enabled || (r.is_enabled === arg.is_enabled))
        return {
          list: list || [],
          count,
          hasMore,
        }
      },
      providesTags: ['modification-categories'],
    }),

    // Modifications
    GET_schoolSetupModifications: builder.query<any, any>({
      query: (params) => ({
        url: '/modifications/',
        params,
      }),
      providesTags: ['modifications'],
    }),
    GET_schoolSetupModificationById: builder.query<any, any>({
      query: (id) => {
        return {
          url: `/modifications/${id}/`,
        }
      },
      providesTags: ['modifications'],
    }),
    POST_schoolSetupModification: builder.mutation<any, any>({
      query: (body) => ({
        url: `/modifications/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['modifications'],
    }),
    PATCH_schoolSetupModification: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/modifications/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['modifications'],
    }),
    DELETE_schoolSetupModification: builder.mutation<any, number>({
      query: (id) => ({
        url: `/modifications/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['modifications'],
    }),
    GET_schoolSetupModificationsSelect: builder.query<any, any>({
      query: (params) => ({
        url: '/modifications/',
        params
      }),
      transformResponse: (response: any, meta: any, arg: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0

        let list = response?.results.filter(r => !arg.is_enabled || (r.is_enabled === arg.is_enabled))
        if(arg.categories)
          list = list.filter(r => r.category && arg.categories.includes(r.category.id))

        return {
          list: list || [],
          count,
          hasMore,
        }
      },
      providesTags: ['modifications'],
    }),

    // AssessmentCategories
    GET_assessmentCategories: builder.query<any, any>({
      query: (params) => ({
        url: '/baseline-assessment-categories/',
        params,
      }),
      providesTags: ['assessment-categories'],
    }),
    POST_assessmentCategoryEnable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/baseline-assessment-categories/${id}/enable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['assessment-categories'],
    }),
    POST_assessmentCategoryDisable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/baseline-assessment-categories/${id}/disable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['assessment-categories'],
    }),
    GET_assessmentCategoriesSelect: builder.query<any, any>({
      query: (params) => ({
        url: 'baseline-assessment-categories/',
        params
      }),
      transformResponse: (response: any, meta: any, arg: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        const list = response?.results.filter(r => !arg.is_enabled || (r.is_enabled === arg.is_enabled))
        return {
          list: list || [],
          count,
          hasMore,
        }
      },
      providesTags: ['assessment-categories'],
    }),

    // Assessment strategies 
    GET_schoolSetupAssessmentStrategies: builder.query<any, any>({
      query: (params) => ({
        url: '/baseline-assessment-strategies/',
        params,
      }),
      providesTags: ['assessment-strategies'],
    }),
    GET_schoolSetupAssessmentStrategyById: builder.query<any, any>({
      query: (id) => {
        return {
          url: `/baseline-assessment-strategies/${id}/`,
        }
      },
      providesTags: ['assessment-strategies'],
    }),
    POST_schoolSetupAssessmentStrategy: builder.mutation<any, any>({
      query: (body) => ({
        url: `/baseline-assessment-strategies/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['assessment-strategies'],
    }),
    PATCH_schoolSetupAssessmentStrategy: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/baseline-assessment-strategies/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['assessment-strategies'],
    }),
    DELETE_schoolSetupAssessmentStrategy: builder.mutation<any, number>({
      query: (id) => ({
        url: `/baseline-assessment-strategies/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['assessment-strategies'],
    }),
    GET_schoolSetupAssessmentStrategiesSelect: builder.query<any, any>({
      query: (params) => ({
        url: '/baseline-assessment-strategies/',
        params
      }),
      transformResponse: (response: any, meta: any, arg: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        let list = response?.results.filter(r => !arg.is_enabled || (r.is_enabled === arg.is_enabled))
        if(arg.categories)
          list = list.filter(r => r.category && arg.categories.includes(r.category.id))
        return {
          list: list || [],
          count,
          hasMore,
        }
      },
      providesTags: ['assessment-strategies'],
    }),

    // Concern reasons
    GET_schoolSetupConcernReasons: builder.query<any, any>({
      query: (params) => ({
        url: '/concern-reasons/',
        params,
      }),
      providesTags: ['concern-reasons'],
    }),
    GET_schoolSetupConcernReasonById: builder.query<any, any>({
      query: (id) => {
        return {
          url: `/concern-reasons/${id}/`,
        }
      },
      providesTags: ['concern-reasons'],
    }),
    POST_schoolSetupConcernReason: builder.mutation<any, any>({
      query: (body) => ({
        url: `/concern-reasons/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['concern-reasons'],
    }),
    PATCH_schoolSetupConcernReason: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/concern-reasons/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['concern-reasons'],
    }),
    DELETE_schoolSetupConcernReason: builder.mutation<any, number>({
      query: (id) => ({
        url: `/concern-reasons/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['concern-reasons'],
    }),
    GET_schoolSetupConcernReasonsSelect: builder.query<any, any>({
      query: (params) => ({
        url: '/concern-reasons/',
        params
      }),
      transformResponse: (response: any, meta: any, arg: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        const list = response?.results.filter(r => !arg.is_enabled || (r.is_enabled === arg.is_enabled))
        return {
          list: list || [],
          count,
          hasMore,
        }
      },
      providesTags: ['concern-reasons'],
    }),
    POST_concernReasonEnable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/concern-reasons/${id}/enable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['concern-reasons'],
    }),
    POST_concernReasonDisable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/concern-reasons/${id}/disable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['concern-reasons'],
    }),
    
    // Lesson plan options 
    GET_schoolSetupLessonPlanOptions: builder.query<any, any>({
      query: (params) => ({
        url: '/group-course-session-plan-options/',
        params,
      }),
      providesTags: ['lesson-plan-options'],
    }),
    GET_schoolSetupLessonPlanOptionById: builder.query<any, any>({
      query: (id) => {
        return {
          url: `/group-course-session-plan-options/${id}/`,
        }
      },
      providesTags: ['lesson-plan-options'],
    }),
    POST_schoolSetupLessonPlanOption: builder.mutation<any, any>({
      query: (body) => ({
        url: `/group-course-session-plan-options/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['lesson-plan-options'],
    }),
    PATCH_schoolSetupLessonPlanOption: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/group-course-session-plan-options/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['lesson-plan-options'],
    }),
    DELETE_schoolSetupLessonPlanOption: builder.mutation<any, number>({
      query: (id) => ({
        url: `/group-course-session-plan-options/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['lesson-plan-options'],
    }),
    GET_schoolSetupLessonPlanOptionsSelect: builder.query<any, any>({
      query: (params) => ({
        url: '/group-course-session-plan-options/',
        params
      }),
      transformResponse: (response: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['lesson-plan-options'],
    }),

    // Instructional Strategy Categories
    GET_instructionalStrategyCategories: builder.query<any, any>({
      query: (params) => ({
        url: '/instructional-strategy-categories/',
        params,
      }),
      providesTags: ['instructional-strategy-categories'],
    }),
    POST_instructionalStrategyCategoryEnable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/instructional-strategy-categories/${id}/enable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['instructional-strategy-categories'],
    }),
    POST_instructionalStrategyCategoryDisable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/instructional-strategy-categories/${id}/disable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['instructional-strategy-categories'],
    }),
    GET_instructionalStrategyCategoriesSelect: builder.query<any, any>({
      query: (params) => ({
        url: 'instructional-strategy-categories/',
        params
      }),
      transformResponse: (response: any, meta: any, arg: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        const list = response?.results.filter(r => !arg.is_enabled || (r.is_enabled === arg.is_enabled))
        return {
          list: list || [],
          count,
          hasMore,
        }
      },
      providesTags: ['instructional-strategy-categories'],
    }),


    // Instructional strategies
    GET_schoolSetupInstructionalStrategies: builder.query<any, any>({
      query: (params) => ({
        url: '/instructional-strategies/',
        params,
      }),
      providesTags: ['instructional-strategies'],
    }),
    GET_schoolSetupInstructionalStrategyById: builder.query<any, any>({
      query: (id) => {
        return {
          url: `/instructional-strategies/${id}/`,
        }
      },
      providesTags: ['instructional-strategies'],
    }),
    POST_schoolSetupInstructionalStrategy: builder.mutation<any, any>({
      query: (body) => ({
        url: `/instructional-strategies/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['instructional-strategies'],
    }),
    PATCH_schoolSetupInstructionalStrategy: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/instructional-strategies/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['instructional-strategies'],
    }),
    DELETE_schoolSetupInstructionalStrategy: builder.mutation<any, number>({
      query: (id) => ({
        url: `/instructional-strategies/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['instructional-strategies'],
    }),
    GET_schoolSetupInstructionalStrategiesSelect: builder.query<any, any>({
      query: (params) => ({
        url: '/instructional-strategies/',
        params
      }),
      transformResponse: (response: any, meta: any, arg: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        let list = response?.results.filter(r => !arg.is_enabled || (r.is_enabled === arg.is_enabled))
        if(arg.categories)
          list = list.filter(r => r.category && arg.categories.includes(r.category.id))
        return {
          list: list || [],
          count,
          hasMore,
        }
      },
      providesTags: ['instructional-strategies'],
    }),

    // Intervention Strategy Categories
    GET_interventionStrategyCategories: builder.query<any, any>({
      query: (params) => ({
        url: '/intervention-strategy-categories/',
        params,
      }),
      providesTags: ['intervention-strategy-categories'],
    }),
    POST_interventionStrategyCategoryEnable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/intervention-strategy-categories/${id}/enable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['intervention-strategy-categories'],
    }),
    POST_interventionStrategyCategoryDisable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/intervention-strategy-categories/${id}/disable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['intervention-strategy-categories'],
    }),
    GET_interventionStrategyCategoriesSelect: builder.query<any, any>({
      query: (params) => ({
        url: 'intervention-strategy-categories/',
        params
      }),
      transformResponse: (response: any, meta: any, arg: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        const list = response?.results.filter(r => !arg.is_enabled || (r.is_enabled === arg.is_enabled))
        return {
          list: list || [],
          count,
          hasMore,
        }
      },
      providesTags: ['intervention-strategy-categories'],
    }),

    // Intervention strategies 
    GET_schoolSetupInterventionStrategies: builder.query<any, any>({
      query: (params) => ({
        url: '/intervention-strategies/',
        params,
      }),
      providesTags: ['intervention-strategies'],
    }),
    GET_schoolSetupInterventionStrategyById: builder.query<any, any>({
      query: (id) => {
        return {
          url: `/intervention-strategies/${id}/`,
        }
      },
      providesTags: ['intervention-strategies'],
    }),
    POST_schoolSetupInterventionStrategy: builder.mutation<any, any>({
      query: (body) => ({
        url: `/intervention-strategies/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['intervention-strategies'],
    }),
    PATCH_schoolSetupInterventionStrategy: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/intervention-strategies/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['intervention-strategies'],
    }),
    DELETE_schoolSetupInterventionStrategy: builder.mutation<any, number>({
      query: (id) => ({
        url: `/intervention-strategies/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['intervention-strategies'],
    }),
    GET_schoolSetupInterventionStrategiesSelect: builder.query<any, any>({
      query: (params) => ({
        url: '/intervention-strategies/',
        params
      }),
      transformResponse: (response: any, meta: any, arg: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        let list = response?.results.filter(r => !arg.is_enabled || (r.is_enabled === arg.is_enabled))
        if(arg.categories)
          list = list.filter(r => r.category && arg.categories.includes(r.category.id))
        return {
          list: list || [],
          count,
          hasMore,
        }
      },
      providesTags: ['intervention-strategies'],
    }),

    // Intervention types
    GET_schoolSetupInterventionTypes: builder.query<any, any>({
      query: (params) => ({
        url: '/intervention-types/',
        params,
      }),
      providesTags: ['intervention-types'],
    }),
    GET_schoolSetupInterventionTypeById: builder.query<any, any>({
      query: (id) => {
        return {
          url: `/intervention-types/${id}/`,
        }
      },
      providesTags: ['intervention-types'],
    }),
    POST_schoolSetupInterventionType: builder.mutation<any, any>({
      query: (body) => ({
        url: `/intervention-types/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['intervention-types'],
    }),
    PATCH_schoolSetupInterventionType: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/intervention-types/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['intervention-types'],
    }),
    DELETE_schoolSetupInterventionType: builder.mutation<any, number>({
      query: (id) => ({
        url: `/intervention-types/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['intervention-types'],
    }),
    GET_schoolSetupInterventionTypesSelect: builder.query<any, any>({
      query: (params) => ({
        url: '/intervention-types/',
        params
      }),
      transformResponse: (response: any, meta: any, arg: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        const list = response?.results.filter(r => !arg.is_enabled || (r.is_enabled === arg.is_enabled))
        return {
          list: list || [],
          count,
          hasMore,
        }
      },
      providesTags: ['intervention-types'],
    }),
    POST_interventionTypeEnable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/intervention-types/${id}/enable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['intervention-types'],
    }),
    POST_interventionTypeDisable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/intervention-types/${id}/disable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['intervention-types'],
    }),

    // Problem areas
    GET_schoolSetupProblemAreas: builder.query<any, any>({
      query: (params) => ({
        url: '/problem-areas/',
        params,
      }),
      providesTags: ['problem-areas'],
    }),
    GET_schoolSetupProblemAreaById: builder.query<any, any>({
      query: (id) => {
        return {
          url: `/problem-areas/${id}/`,
        }
      },
      providesTags: ['problem-areas'],
    }),
    POST_schoolSetupProblemArea: builder.mutation<any, any>({
      query: (body) => ({
        url: `/problem-areas/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['problem-areas'],
    }),
    PATCH_schoolSetupProblemArea: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/problem-areas/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['problem-areas'],
    }),
    DELETE_schoolSetupProblemArea: builder.mutation<any, number>({
      query: (id) => ({
        url: `/problem-areas/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['problem-areas'],
    }),
    GET_schoolSetupProblemAreasSelect: builder.query<any, any>({
      query: (params) => ({
        url: '/problem-areas/',
        params
      }),
      transformResponse: (response: any, meta: any, arg: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        const list = response?.results.filter(r => !arg.is_enabled || (r.is_enabled === arg.is_enabled))
        return {
          list: list || [],
          count,
          hasMore,
        }
      },
      providesTags: ['problem-areas'],
    }),
    POST_problemAreaEnable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/problem-areas/${id}/enable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['problem-areas'],
    }),
    POST_problemAreaDisable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/problem-areas/${id}/disable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['problem-areas'],
    }),

    // Progress monitoring tools
   GET_schoolSetupProgressMonitoringTools: builder.query<any, any>({
      query: (params) => ({
        url: '/progress-monitoring-tools/',
        params,
      }),
      providesTags: ['progress-monitoring-tools'],
    }),
    GET_schoolSetupProgressMonitoringToolById: builder.query<any, any>({
      query: (id) => {
        return {
          url: `/progress-monitoring-tools/${id}/`,
        }
      },
      providesTags: ['progress-monitoring-tools'],
    }),
    POST_schoolSetupProgressMonitoringTool: builder.mutation<any, any>({
      query: (body) => ({
        url: `/progress-monitoring-tools/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['progress-monitoring-tools'],
    }),
    PATCH_schoolSetupProgressMonitoringTool: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/progress-monitoring-tools/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['progress-monitoring-tools'],
    }),
    DELETE_schoolSetupProgressMonitoringTool: builder.mutation<any, number>({
      query: (id) => ({
        url: `/progress-monitoring-tools/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['progress-monitoring-tools'],
    }),
    GET_schoolSetupProgressMonitoringToolsSelect: builder.query<any, any>({
      query: (params) => ({
        url: '/progress-monitoring-tools/',
        params
      }),
      transformResponse: (response: any, meta: any, arg: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        const list = response?.results.filter(r => !arg.is_enabled || (r.is_enabled === arg.is_enabled))
        return {
          list: list || [],
          count,
          hasMore,
        }
      },
      providesTags: ['progress-monitoring-tools'],
    }),
    POST_progressMonitoringToolEnable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/progress-monitoring-tools/${id}/enable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['progress-monitoring-tools'],
    }),
    POST_progressMonitoringToolDisable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/progress-monitoring-tools/${id}/disable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['progress-monitoring-tools'],
    }),

    // Monitoring methods
    GET_schoolSetupMonitoringMethods: builder.query<any, any>({
      query: (params) => ({
        url: '/monitoring-methods/',
        params,
      }),
      providesTags: ['monitoring-methods'],
    }),
    GET_schoolSetupMonitoringMethodById: builder.query<any, any>({
      query: (id) => {
        return {
          url: `/monitoring-methods/${id}/`,
        }
      },
      providesTags: ['monitoring-methods'],
    }),
    POST_schoolSetupMonitoringMethod: builder.mutation<any, any>({
      query: (body) => ({
        url: `/monitoring-methods/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['monitoring-methods'],
    }),
    PATCH_schoolSetupMonitoringMethod: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/monitoring-methods/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['monitoring-methods'],
    }),
    DELETE_schoolSetupMonitoringMethod: builder.mutation<any, number>({
      query: (id) => ({
        url: `/monitoring-methods/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['monitoring-methods'],
    }),
    GET_schoolSetupMonitoringMethodsSelect: builder.query<any, any>({
      query: (params) => ({
        url: '/monitoring-methods/',
        params
      }),
      transformResponse: (response: any, meta: any, arg: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        const list = response?.results.filter(r => !arg.is_enabled || (r.is_enabled === arg.is_enabled))
        return {
          list: list || [],
          count,
          hasMore,
        }
      },
      providesTags: ['monitoring-methods'],
    }),
    POST_monitoringMethodEnable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/monitoring-methods/${id}/enable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['monitoring-methods'],
    }),
    POST_monitoringMethodDisable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/monitoring-methods/${id}/disable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['monitoring-methods'],
    }),

    // Subjects
    GET_schoolSetupSubjects: builder.query<any, any>({
      query: (params) => ({
        url: '/subjects/',
        params,
      }),
      providesTags: ['subjects'],
    }),
    GET_schoolSetupSubjectsSelect: builder.query<any, any>({
      query: (params) => ({
        url: '/subjects/',
        params
      }),
      transformResponse: (response: any, meta: any, arg: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        const list = response?.results.filter(r => !arg.is_enabled || (r.is_enabled === arg.is_enabled))
        return {
          list: list || [],
          count,
          hasMore,
        }
      },
      providesTags: ['subjects'],
    }),
    POST_subjectEnable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/subjects/${id}/enable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['subjects'],
    }),
    POST_subjectDisable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/subjects/${id}/disable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['subjects'],
    }),
    
    // Topics
    GET_schoolSetupTopics: builder.query<any, any>({
      query: (params) => ({
        url: '/topics/',
        params,
      }),
      providesTags: ['goal-topics'],
    }),
    GET_schoolSetupTopicsSelect: builder.query<any, any>({
      query: (params) => ({
        url: '/topics/',
        params
      }),
      transformResponse: (response: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['goal-topics'],
    }),
    POST_topicEnable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/topics/${id}/enable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['goal-topics'],
    }),
    POST_topicDisable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/topics/${id}/disable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['goal-topics'],
    }),
    


    // Fluencies 
    GET_schoolSetupFluencies: builder.query<any, any>({
      query: (params) => ({
        url: '/fluencies/',
        params,
      }),
      providesTags: ['goal-fluencies'],
    }),
    GET_schoolSetupFluenciesSelect: builder.query<any, any>({
      query: (params) => ({
        url: '/fluencies/',
        params
      }),
      providesTags: ['goal-fluencies'],
    }),
    POST_fluencyEnable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/fluencies/${id}/enable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['goal-fluencies'],
    }),
    POST_fluencyDisable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/fluencies/${id}/disable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['goal-fluencies'],
    }),
    

    // Highlights
    GET_schoolSetupHighlights: builder.query<any, any>({
      query: (params) => ({
        url: '/highlights/',
        params,
      }),
      providesTags: ['goal-highlights'],
    }),
    GET_schoolSetupHighlightsSelect: builder.query<any, any>({
      query: (params) => ({
        url: '/highlights/',
        params
      }),
      transformResponse: (response: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['goal-highlights'],
    }),
    POST_highlightEnable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/highlights/${id}/enable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['goal-highlights'],
    }),
    POST_highlightDisable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/highlights/${id}/disable/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['goal-highlights'],
    }),

  // Measures
  GET_schoolSetupMeasures: builder.query<any, any>({
    query: (params) => ({
      url: '/measures/',
      params,
    }),
    providesTags: ['goal-measures'],
  }),
  GET_schoolSetupMeasuresSelect: builder.query<any, any>({
    query: (params) => ({
      url: '/measures/',
      params
    }),
    transformResponse: (response: any) => {
      const hasMore = Boolean(response?.next)
      const count = response?.count || 0
      return {
        list: response?.results || [],
        count,
        hasMore,
      }
    },
    providesTags: ['goal-measures'],
  }),
  POST_measureEnable: builder.mutation<any, { id: number; body: any }>({
    query: ({ id, body }) => ({
      url: `/measures/${id}/enable/`,
      method: 'POST',
      body,
    }),
    invalidatesTags: ['goal-measures'],
  }),
  POST_measureDisable: builder.mutation<any, { id: number; body: any }>({
    query: ({ id, body }) => ({
      url: `/measures/${id}/disable/`,
      method: 'POST',
      body,
    }),
    invalidatesTags: ['goal-measures'],
  }),

  // Skills
  GET_schoolSetupSkills: builder.query<any, any>({
    query: (params) => ({
      url: '/skills/',
      params,
    }),
    providesTags: ['goal-skills'],
  }),
  GET_schoolSetupSkillsSelect: builder.query<any, any>({
    query: (params) => ({
      url: '/skills/',
      params
    }),
    transformResponse: (response: any) => {
      const hasMore = Boolean(response?.next)
      const count = response?.count || 0
      return {
        list: response?.results || [],
        count,
        hasMore,
      }
    },
    providesTags: ['goal-skills'],
  }),
  POST_skillEnable: builder.mutation<any, { id: number; body: any }>({
    query: ({ id, body }) => ({
      url: `/skills/${id}/enable/`,
      method: 'POST',
      body,
    }),
    invalidatesTags: ['goal-skills'],
  }),
  POST_skillDisable: builder.mutation<any, { id: number; body: any }>({
    query: ({ id, body }) => ({
      url: `/skills/${id}/disable/`,
      method: 'POST',
      body,
    }),
    invalidatesTags: ['goal-skills'],
  }),

    // PLOP categories
    GET_schoolSetupPlopCategories: builder.query<any, any>({
      query: (params) => ({
        url: '/plop-categories/',
        params,
      }),
      providesTags: ['plop-categories'],
    }),
    GET_schoolSetupPlopCategoryById: builder.query<any, any>({
      query: (id) => {
        return {
          url: `/plop-categories/${id}/`,
        }
      },
      providesTags: ['plop-categories'],
    }),
    POST_schoolSetupPlopCategory: builder.mutation<any, any>({
      query: (body) => ({
        url: `/plop-categories/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['plop-categories'],
    }),
    PATCH_schoolSetupPlopCategory: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/plop-categories/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['plop-categories'],
    }),
    DELETE_schoolSetupPlopCategory: builder.mutation<any, number>({
      query: (id) => ({
        url: `/plop-categories/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['plop-categories'],
    }),
    GET_schoolSetupPlopCategoriesSelect: builder.query<any, any>({
      query: (params) => ({
        url: '/plop-categories/',
        params
      }),
      transformResponse: (response: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['plop-categories'],
    }),

    // Meeting categories
    GET_schoolSetupMeetingCategories: builder.query<any, any>({
      query: (params) => ({
        url: '/meeting-categories/',
        params,
      }),
      providesTags: ['meeting-categories'],
    }),
    GET_schoolSetupMeetingCategoryById: builder.query<any, any>({
      query: (id) => {
        return {
          url: `/meeting-categories/${id}/`,
        }
      },
      providesTags: ['meeting-categories'],
    }),
    POST_schoolSetupMeetingCategory: builder.mutation<any, any>({
      query: (body) => ({
        url: `/meeting-categories/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['meeting-categories'],
    }),
    PATCH_schoolSetupMeetingCategory: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/meeting-categories/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['meeting-categories'],
    }),
    DELETE_schoolSetupMeetingCategory: builder.mutation<any, number>({
      query: (id) => ({
        url: `/meeting-categories/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['meeting-categories'],
    }),
    GET_schoolSetupMeetingCategoriesSelect: builder.query<any, any>({
      query: (params) => ({
        url: '/meeting-categories/',
        params
      }),
      transformResponse: (response: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['meeting-categories'],
    }),

    // Assessment type
    GET_schoolSetupAssessmentTypes: builder.query<any, any>({
      query: (params) => ({
        url: '/school-setup/assessment-types/',
        params,
      }),
      providesTags: ['assessment-types'],
    }),
    PUT_schoolSetupAssessmentTypeEnable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/school-setup/assessment-types/${id}/enable/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['assessment-types'],
    }),
    PUT_schoolSetupAssessmentTypeDisable: builder.mutation<any, {id: number}>({
      query: (id) => ({
        url: `/school-setup/assessment-types/${id}/disable/`,
        method: 'PUT',
      }),
      invalidatesTags: ['assessment-types'],
    }),
    GET_schoolSetupAssessmentTypesSelect: builder.query<any, any>({
      query: (params) => ({
        url: '/school-setup/assessment-types/',
        params,
      }),
      providesTags: ['assessment-types'],
      transformResponse: (response: any) => {
        const hasMore = false
        const count = response?.length ?? 0
        return {
          list: response?.filter(r => r.is_active).map(r => { return {
            id: r.option,
            title: r.title
          } }),
          count,
          hasMore,
        }
      },
    }),



    // Submission type 
    GET_schoolSetupSubmissionTypes: builder.query<any, any>({
      query: (params) => ({
        url: '/school-setup/submission-types/',
        params,
      }),
      providesTags: ['submission-types'],
    }),
    PUT_schoolSetupSubmissionTypeEnable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/school-setup/submission-types/${id}/enable/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['submission-types'],
    }),
    PUT_schoolSetupSubmissionTypeDisable: builder.mutation<any, {id: number}>({
      query: (id) => ({
        url: `/school-setup/submission-types/${id}/disable/`,
        method: 'PUT',
      }),
      invalidatesTags: ['submission-types'],
    }),

    // Score type
    GET_schoolSetupScoreTypes: builder.query<any, any>({
      query: (params) => ({
        url: '/school-setup/score-types/',
        params,
      }),
      providesTags: ['score-types'],
    }),
    PUT_schoolSetupScoreTypeEnable: builder.mutation<any, { id: number; body: any }>({
      query: ({ id, body }) => ({
        url: `/school-setup/score-types/${id}/enable/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['score-types'],
    }),
    PUT_schoolSetupScoreTypeDisable: builder.mutation<any, {id: number}>({
      query: (id) => ({
        url: `/school-setup/score-types/${id}/disable/`,
        method: 'PUT',
      }),
      invalidatesTags: ['score-types'],
    }),
  }),
})

export const { 
  useGET_schoolSetupAccommodationsQuery, 
  useGET_schoolSetupAccommodationByIdQuery,
  usePOST_schoolSetupAccommodationMutation,
  usePATCH_schoolSetupAccommodationMutation,
  useDELETE_schoolSetupAccommodationMutation,
  useGET_schoolSetupAccommodationsSelectQuery,

  useGET_schoolSetupModificationsQuery, 
  useGET_schoolSetupModificationByIdQuery,
  usePOST_schoolSetupModificationMutation,
  usePATCH_schoolSetupModificationMutation,
  useDELETE_schoolSetupModificationMutation,
  useGET_schoolSetupModificationsSelectQuery,

  useGET_schoolSetupAssessmentStrategiesQuery, 
  useGET_schoolSetupAssessmentStrategyByIdQuery,
  usePOST_schoolSetupAssessmentStrategyMutation,
  usePATCH_schoolSetupAssessmentStrategyMutation,
  useDELETE_schoolSetupAssessmentStrategyMutation,
  useGET_schoolSetupAssessmentStrategiesSelectQuery,

  useGET_schoolSetupConcernReasonsQuery, 
  useGET_schoolSetupConcernReasonByIdQuery,
  usePOST_schoolSetupConcernReasonMutation,
  usePATCH_schoolSetupConcernReasonMutation,
  useDELETE_schoolSetupConcernReasonMutation,
  useGET_schoolSetupConcernReasonsSelectQuery,
  usePOST_concernReasonEnableMutation,
  usePOST_concernReasonDisableMutation,

  useGET_schoolSetupLessonPlanOptionsQuery, 
  useGET_schoolSetupLessonPlanOptionByIdQuery,
  usePOST_schoolSetupLessonPlanOptionMutation,
  usePATCH_schoolSetupLessonPlanOptionMutation,
  useDELETE_schoolSetupLessonPlanOptionMutation,
  useGET_schoolSetupLessonPlanOptionsSelectQuery,

  useGET_schoolSetupInstructionalStrategiesQuery, 
  useGET_schoolSetupInstructionalStrategyByIdQuery,
  usePOST_schoolSetupInstructionalStrategyMutation,
  usePATCH_schoolSetupInstructionalStrategyMutation,
  useDELETE_schoolSetupInstructionalStrategyMutation,
  useGET_schoolSetupInstructionalStrategiesSelectQuery,

  useGET_schoolSetupInterventionStrategiesQuery, 
  useGET_schoolSetupInterventionStrategyByIdQuery,
  usePOST_schoolSetupInterventionStrategyMutation,
  usePATCH_schoolSetupInterventionStrategyMutation,
  useDELETE_schoolSetupInterventionStrategyMutation,
  useGET_schoolSetupInterventionStrategiesSelectQuery,
 
  useGET_schoolSetupInterventionTypesQuery, 
  useGET_schoolSetupInterventionTypeByIdQuery,
  usePOST_schoolSetupInterventionTypeMutation,
  usePATCH_schoolSetupInterventionTypeMutation,
  useDELETE_schoolSetupInterventionTypeMutation,
  useGET_schoolSetupInterventionTypesSelectQuery,
  usePOST_interventionTypeEnableMutation,
  usePOST_interventionTypeDisableMutation,

  useGET_schoolSetupProblemAreasQuery, 
  useGET_schoolSetupProblemAreaByIdQuery,
  usePOST_schoolSetupProblemAreaMutation,
  usePATCH_schoolSetupProblemAreaMutation,
  useDELETE_schoolSetupProblemAreaMutation,
  useGET_schoolSetupProblemAreasSelectQuery,
  usePOST_problemAreaEnableMutation,
  usePOST_problemAreaDisableMutation,

  useGET_schoolSetupProgressMonitoringToolsQuery, 
  useGET_schoolSetupProgressMonitoringToolByIdQuery,
  usePOST_schoolSetupProgressMonitoringToolMutation,
  usePATCH_schoolSetupProgressMonitoringToolMutation,
  useDELETE_schoolSetupProgressMonitoringToolMutation,
  useGET_schoolSetupProgressMonitoringToolsSelectQuery,
  usePOST_progressMonitoringToolEnableMutation,
  usePOST_progressMonitoringToolDisableMutation,

  useGET_schoolSetupMonitoringMethodsQuery, 
  useGET_schoolSetupMonitoringMethodByIdQuery,
  usePOST_schoolSetupMonitoringMethodMutation,
  usePATCH_schoolSetupMonitoringMethodMutation,
  useDELETE_schoolSetupMonitoringMethodMutation,
  useGET_schoolSetupMonitoringMethodsSelectQuery,
  usePOST_monitoringMethodEnableMutation,
  usePOST_monitoringMethodDisableMutation,

  useGET_schoolSetupSubjectsQuery,
  useGET_schoolSetupSubjectsSelectQuery,
  usePOST_subjectEnableMutation,
  usePOST_subjectDisableMutation,

  useGET_schoolSetupTopicsQuery, 
  useGET_schoolSetupTopicsSelectQuery,
  usePOST_topicEnableMutation,
  usePOST_topicDisableMutation,

  useGET_schoolSetupFluenciesQuery, 
  useGET_schoolSetupFluenciesSelectQuery,
  usePOST_fluencyEnableMutation,
  usePOST_fluencyDisableMutation,

  useGET_schoolSetupHighlightsQuery, 
  useGET_schoolSetupHighlightsSelectQuery,
  usePOST_highlightEnableMutation,
  usePOST_highlightDisableMutation,

  useGET_schoolSetupSkillsQuery, 
  useGET_schoolSetupSkillsSelectQuery,
  usePOST_skillEnableMutation,
  usePOST_skillDisableMutation,

  useGET_schoolSetupMeasuresQuery, 
  useGET_schoolSetupMeasuresSelectQuery,
  usePOST_measureEnableMutation,
  usePOST_measureDisableMutation,

  useGET_schoolSetupPlopCategoriesQuery, 
  useGET_schoolSetupPlopCategoryByIdQuery,
  usePOST_schoolSetupPlopCategoryMutation,
  usePATCH_schoolSetupPlopCategoryMutation,
  useDELETE_schoolSetupPlopCategoryMutation,
  useGET_schoolSetupPlopCategoriesSelectQuery,

  useGET_schoolSetupMeetingCategoriesQuery, 
  useGET_schoolSetupMeetingCategoryByIdQuery,
  usePOST_schoolSetupMeetingCategoryMutation,
  usePATCH_schoolSetupMeetingCategoryMutation,
  useDELETE_schoolSetupMeetingCategoryMutation,
  useGET_schoolSetupMeetingCategoriesSelectQuery,

  useGET_schoolSetupAssessmentTypesQuery, 
  usePUT_schoolSetupAssessmentTypeEnableMutation,
  usePUT_schoolSetupAssessmentTypeDisableMutation,
  useGET_schoolSetupAssessmentTypesSelectQuery,

  useGET_schoolSetupSubmissionTypesQuery, 
  usePUT_schoolSetupSubmissionTypeEnableMutation,
  usePUT_schoolSetupSubmissionTypeDisableMutation,

  useGET_schoolSetupScoreTypesQuery, 
  usePUT_schoolSetupScoreTypeEnableMutation,
  usePUT_schoolSetupScoreTypeDisableMutation,

  useGET_accommodationCategoriesQuery,
  usePOST_accommodationCategoryEnableMutation,
  usePOST_accommodationCategoryDisableMutation,
  useGET_accommodationCategoriesSelectQuery,

  useGET_modificationCategoriesQuery,
  usePOST_modificationCategoryEnableMutation,
  usePOST_modificationCategoryDisableMutation,
  useGET_modificationCategoriesSelectQuery,

  useGET_assessmentCategoriesQuery,
  usePOST_assessmentCategoryEnableMutation,
  usePOST_assessmentCategoryDisableMutation,
  useGET_assessmentCategoriesSelectQuery,

  useGET_instructionalStrategyCategoriesQuery,
  usePOST_instructionalStrategyCategoryEnableMutation,
  usePOST_instructionalStrategyCategoryDisableMutation,
  useGET_instructionalStrategyCategoriesSelectQuery,

  useGET_interventionStrategyCategoriesQuery,
  usePOST_interventionStrategyCategoryEnableMutation,
  usePOST_interventionStrategyCategoryDisableMutation,
  useGET_interventionStrategyCategoriesSelectQuery,

  useGET_setupOptionsQuery,
  usePOST_setupOptionEnableMutation,
  usePOST_setupOptionDisableMutation,
} = setupAPI
